import _ from 'lodash';
import constants from '$$helpers/constants';
import svg from '$$helpers/svgToURI';
import icon_resource from '../../../svg/default/default-ava.svg';

export const DEFAULT_VALUES_BY_COLUMN_TYPE = {
  [constants.CUSTOM_COLUMNS_TYPES.text.id]: '',
  [constants.CUSTOM_COLUMNS_TYPES.number.id]: 0,
  [constants.CUSTOM_COLUMNS_TYPES.checkbox.id]: 0,
  [constants.CUSTOM_COLUMNS_TYPES.date.id]: '',
  [constants.CUSTOM_COLUMNS_TYPES.resources.id]: '',
};

export function getTemplateForColorSelect(color) {
  return `<span class="custom_column_option_color" style="background: ${color || 'transparent'}"></span>`;
}

export function getTemplateForListSelect(text) {
  return `<span class="custom_column_option_list">${text}</span>`;
}

export function getTemplateForListMultiSelect(text) {
  return `<span class="custom_column_option_list">${text}</span>`;
}

export function getTemplateForCheckbox(val) {
  const checked = Number(val) ? ' checked' : '';

  // return `<input class="custom_column_checkbox ${checked ? ' active' : ''}" type='checkbox' ${checked}/>`;
  return `<span class="custom_column_checkbox ${checked ? ' active' : ''}"></span>`;
}

export function getTemplateForText(val) {
  return `<div class="custom_column_text" title="${_.escape(val)}">${_.escape(val)}</div>`;
}

export function getTemplateForTags(items) {
  let resultTag = '';
  const maxElemsToShow = 2;

  if (items.length && items.length <= maxElemsToShow) {
    resultTag = items.map(elem => {
      const tag = `<span class="tag-text">${elem.value}</span>`;

      return `<span class="tag-item" style="background: ${elem.color}">${tag}</span>`;
    })
      .join('');
  }

  if (items.length && items.length > maxElemsToShow) {
    const tags = items.slice(0, maxElemsToShow)
      .map(elem => {
        const tag = `<span class="tag-text">${elem.value[0]}</span>`;

        return `<span class="tag-item" style="width: 18px; background: ${elem.color}">${tag}</span>`;
      })
      .join('');

    resultTag = `${tags}${items.length > maxElemsToShow ? `<span>+${items.length - maxElemsToShow}</span>` : ''}`;
  }

  return resultTag;
}

export function getTemplateForListResources(resources) {
  let resultTag = '';
  const maxElemsToShow = 2;

  if (resources.length && resources.length < maxElemsToShow) {
    const picture = `<span class="resources-icon" style="background-image: url(${resources[0].picture})"></span>`;
    const text = `<span class="resources-text">${resources[0].value}</span>`;

    resultTag = `<span class="resources-item">${picture}${text}</span>`;
  }

  if (resources.length && resources.length >= maxElemsToShow) {
    const iconTags = resources.slice(0, maxElemsToShow)
      .map(elem => {
        const picture = elem.picture ? `<span class="resources-icon" style="background-image: url(${elem.picture})"></span>` : '';

        return `<span class="resources-item">${picture}</span>`;
      })
      .join('');

    resultTag = `${iconTags}${resources.length > maxElemsToShow ? `+${resources.length - maxElemsToShow}` : ''}`;
  }

  return resultTag;
}

export function prepareOptionsForResources(options, resources) {
  return options.reduce((result, option) => {
    const resource = resources.find(item => item.id === option.resource_id);

    if (resource) {
      result.push({
        ...resource,
        id: option.id,
        sort_order: option.sort_order,
        picture: resource.picture || svg(icon_resource),
        value: resource.name,
      });
    }

    return result;
  }, []);
}
